import { render, staticRenderFns } from "./listaItensPregao.vue?vue&type=template&id=2838ed28"
import script from "./listaItensPregao.vue?vue&type=script&lang=js"
export * from "./listaItensPregao.vue?vue&type=script&lang=js"
import style0 from "./listaItensPregao.vue?vue&type=style&index=0&id=2838ed28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports